import React from 'react';
import { XCircle, ArrowLeft } from 'react-feather';
import {
  Box, IconButton, makeStyles, SvgIcon, Typography
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SideDrawer from '../../../../../components/Drawer';

const useStyles = makeStyles((theme) => ({
  drawer: {
    position: 'relative',
  },
  children: {
    height: '100%'
  }
}));

interface Props {
  handleClose?: () => void,
  children?: React.ReactNode,
}

const BaseDrawer = ({
  handleClose,
  children
}: Props) => {
  const classes = useStyles();
  return (
    <SideDrawer
      handleClose={handleClose}
      className={classes.drawer}
      variant="permanent"
    >
      <PerfectScrollbar options={{ suppressScrollX: true }}>
        <Box pl={2} pr={2} pb={2} className={classes.children}>
          {children}
        </Box>
      </PerfectScrollbar>
    </SideDrawer>
  );
};

export default BaseDrawer;
